module.exports = __webpack_public_path__ + "img/icon_fb.fcae87cd.svg";